import React from "react";

import throttle from 'lodash.throttle';
import UsageMaintenancePage, { IUsageMaintenancePageProps } from "./UsageMaintenancePage";
import { EVENT_HANDLER_THROTTLE_TIME } from "../../../Consts";


const UsageMaintenancePageScrollListener: React.FC<IUsageMaintenancePageProps> = (props) => {
    const [updatedScroll, setUpdatedScroll] = React.useState(0);
    React.useEffect(() => {
        window.addEventListener(
            "scroll",
            throttle(handleScroll, EVENT_HANDLER_THROTTLE_TIME, {
                trailing: true
            })
        );
        return  window.removeEventListener(
            "scroll",
            throttle(handleScroll, EVENT_HANDLER_THROTTLE_TIME, {
                leading: true
            })
        );
    }, []);
    const handleScroll = () => {
        setUpdatedScroll(window.scrollY);
    };
    return <UsageMaintenancePage {...props} updatedScroll={updatedScroll} />
    
}
export default UsageMaintenancePageScrollListener;